import { render, staticRenderFns } from "./TaskEdit.vue?vue&type=template&id=d19d9f00&scoped=true&"
import script from "./TaskEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./TaskEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19d9f00",
  null
  
)

export default component.exports